export const createChipObserver: () => ResizeObserver = () => {
  return new ResizeObserver((entries: ResizeObserverEntry[]) => {
    entries.forEach((entry) => {
      const chip = entry.target as HTMLDivElement;
      chip?.style.setProperty('font-size', `${chip.clientWidth}px`);
    });
  });
};

export const createValueObserver: () => ResizeObserver = () => {
  return new ResizeObserver((entries: ResizeObserverEntry[]) => {
    entries.forEach((entry: ResizeObserverEntry) => {
      const valueContainer = entry.target.parentElement as HTMLDivElement;
      const value = entry.target as HTMLDivElement;
      if (!valueContainer || !value) return;
      const valueWidth = value.clientWidth;
      const valueHeight = value.clientHeight;
      const horizontalSize = valueWidth / valueContainer.clientWidth;
      const verticalSize = valueHeight / valueContainer.clientHeight;
      const horizontalLimit = 0.73;
      const verticalLimit = 0.36;
      const horizontalScale = horizontalLimit / horizontalSize;
      const verticalScale = verticalLimit / verticalSize;
      const targetScale = Math.min(horizontalScale, verticalScale);
      if (targetScale < 1) {
        value.style.setProperty('--scale', targetScale.toString());
      } else {
        value.style.removeProperty('--scale');
      }
    });
  });
};
